<script lang="ts">
  import ScheduleEventActionValidationDialog from "./_modules/schedule-event-action-validation-dialog"
  import {
    resolveScheduleEventActionValidationDialog,
    scheduleEventActionValidationDialogs,
    type ScheduleEventActionValidationDialogEntry,
  } from "../../_shared/_logic/confirm-schedule-event-action-issues"

  const activeDialog = $derived($scheduleEventActionValidationDialogs[0] ?? null)
  let processing = $state(false)

  const resolve = (entry: ScheduleEventActionValidationDialogEntry, confirmed: boolean) => {
    if (processing) return

    processing = true
    try {
      resolveScheduleEventActionValidationDialog(entry, confirmed)
    } finally {
      processing = false
    }
  }
</script>

{#if activeDialog}
  <ScheduleEventActionValidationDialog
    issues={activeDialog.issues}
    context={activeDialog.context}
    {processing}
    onConfirm={() => resolve(activeDialog, true)}
    onCancel={() => resolve(activeDialog, false)}
  />
{/if}
